import angularModule from 'Translation/angularModule/scripts/translation_module';

angularModule.factory('translationLoader', [
    '$injector',
    // The translations are on the window.locales object, but angular-translate needs a loader that
    // returns a promise (see forceAsyncReload in translation_module.js).
    () => options => Promise.resolve(window.locales[options.key]),
]);
